import { render, staticRenderFns } from "./ChecklistNew.vue?vue&type=template&id=5320e780&"
import script from "./ChecklistNew.vue?vue&type=script&lang=js&"
export * from "./ChecklistNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports